import moment from "moment-timezone";
import Moment from "moment-jalaali";

const fa = require("../translations/fa.json");
const en = require("../translations/en.json");

const Translation = {
  si_symbol: ["", "k", "M", "G", "T", "P", "E"],
  enNum: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"],
  faNum: ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"],
  translations: fa,
  langs: [
    { lang: "fa", translation: fa },
    { lang: "en", translation: en },
  ],

  changeTranslation(lang) {
    const translation = Translation.langs.filter((t) => t.lang === lang);
    Translation.translations = translation[0].translation;
  },

  date(d) {
    const tz = moment.tz.guess();
    if (Translation.translations.lang === "fa") {
      Moment.loadPersian({ usePersianDigits: true, dialect: "persian-modern" });
      return `${Moment(d).tz(tz).format("LL")} - ${Moment(d)
        .tz(tz)
        .format("LT")}`;
    } else {
      const left = moment(d).tz(tz).format("L").replaceAll("j", "");
      const right = moment(d).tz(tz).format("LT");
      return `${Translation.toEnNum(left)} - ${Translation.toEnNum(right)}`;
    }
  },

  dateWithoutTime(d) {
    const tz = moment.tz.guess();
    if (Translation.translations.lang === "fa") {
      Moment.loadPersian({ usePersianDigits: true, dialect: "persian-modern" });
      return Moment(d).tz(tz).format("LL");
    } else {
      const val = moment(d).tz(tz).format("L").replaceAll("j", "");
      return Translation.toEnNum(val);
    }
  },

  time(d) {
    const tz = moment.tz.guess();
    if (Translation.translations.lang === "fa") {
      Moment.loadPersian({ usePersianDigits: true, dialect: "persian-modern" });
      return Moment(d).tz(tz).format("LT");
    } else {
      const val = Moment(d).tz(tz).format("LT");
      return Translation.toEnNum(val);
    }
  },

  t(key, params) {
    let str = Translation.translations[key];
    if (!str) return key;
    if (!params) return str;

    Object.keys(params).forEach((p) => {
      const replaceParams =
        typeof params[p] === "number"
          ? Translation.n(params[p], { fraction: 0 })
          : params[p];
      const regex = new RegExp(`%${p}%`, "gm");
      str = str.replace(regex, replaceParams);
    });

    return str;
  },

  n(
    str,
    options = {
      comma: false,
      commarize: false,
      unit: "",
      fraction: 0,
      currency: "",
    }
  ) {
    if (str === null || str === undefined) return str;

    let number = str;
    if (typeof number === "number") {
      number = number.toFixed(options.fraction);
    }

    if (options.commarize) {
      number = Number(number);
      const min = 100000;
      if (typeof number === "number" && number >= min) {
        const tier = (Math.log10(number) / 3) | 0;
        const suffix = Translation.si_symbol[tier];
        const scale = 10 ** (tier * 3);
        const scaled = number / scale;
        number = scaled.toFixed(1) + suffix;
      }
    }

    number = number.toString();

    if (options.comma) {
      number = number.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    if (Translation.translations.numbers) {
      number = number.replace(
        /\d/g,
        (digit) => Translation.translations.numbers[digit]
      );
    }

    return number;
  },

  toEnNum(str) {
    if (str === null || str === undefined) return str;

    let newStr = String(str);

    const hasReplaceAll = typeof newStr.replaceAll === "function";

    for (let i = 0; i < Translation.enNum.length; i += 1) {
      const faD = Translation.faNum[i];
      const enD = Translation.enNum[i];
      newStr = hasReplaceAll
        ? newStr.replaceAll(faD, enD)
        : newStr.split(faD).join(enD);
    }
    return newStr;
  },
};

export default Translation;
